module.exports = __webpack_public_path__ + "static/media/main3_en_768-min.2fb9f5ff.png";